import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LandingPageDesignerIcon, LandingPageGalleryIcon } from '@dev/ee-components';
import { Grid } from '@material-ui/core';
import { OpenGallery, TemplateLoadStart } from '@/store/landingPageCreator/actions';
import { ContentBox } from '@/assets/ContentBox';
import { useDashboardElementVisibility } from '@/services/hooks/useDashboardElementVisibility';
import { TemplatesGallery } from '../../components/TemplatesGallery';

export const Step2EditContent = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { linkInBio: { isLinkInBioInsteadLandingPageVisible } } = useDashboardElementVisibility();
    
    const openTemplatesGallery = (): void => {
        dispatch(OpenGallery());
    };

    const openLandingPageDesigner = (): void => {
        dispatch(TemplateLoadStart());
    };

    return (
        <Grid container spacing={3}>
            <ContentBox
                id="landingpage-creator-gallery-box"
                icon={<LandingPageGalleryIcon />}
                title={t('gallery')}
                description={isLinkInBioInsteadLandingPageVisible ? t('linkinbio_choosefromgallery') : t('lp_creator_choosefromgallery')}
                onBoxClick={openTemplatesGallery}
            />
            <ContentBox
                id="landingpage-creator-scratch-box"
                icon={<LandingPageDesignerIcon />}
                title={t('startfromscratch')}
                description={isLinkInBioInsteadLandingPageVisible ? t('linkinbio_uselpdesigner') : t('lp_creator_uselpdesigner')}
                onBoxClick={openLandingPageDesigner}
            />
            <TemplatesGallery />
        </Grid>
    );
};
